module.exports = __webpack_public_path__ + "assets/img/jianxia_score-04d2db06.png";